export default __webpack_public_path__ + "static/media/Desenvolvimento-de-Software-PT.23a03ad8.jpg";